// DS: DS6.1 - Checkbox Semantics
import React from 'react';
import c from 'classnames';
import Checkbox, { type CheckboxProps } from '../../../../Checkbox';
import { setRefs } from '../../../../../utils/refHelpers';
import { CommonListItemAPI, useListItem } from '../../common';
import ListItemContent from '../../legos/ListItemContent';
import commonStyles from '../../common.scss';
import s from './ListItemCheckbox.scss';

export interface Props
  extends Omit<CheckboxProps, 'inputClassName' | 'className' | 'isChecked'>, CommonListItemAPI {
  className?: string;
  inputClassName?: string;
  value?: string;
  controlAlignment?: 'top' | 'center';
}

const ListItemCheckbox: React.FC<Props> = unfilteredProps => {
  const {
    rootProps: {
      className,
      inputClassName,
      innerRef,
      checked,
      name,
      value,
      controlAlignment = 'top',
      ...rest
    },
    contentProps,
    ref,
  } = useListItem<HTMLElement, Props>(unfilteredProps);

  return (
    // TODO: Still not a11y, can't activate the checkbox with keyboard. Need to refactor base checkbox component
    <Checkbox
      // TODO: Add role="checkbox"? Use da-a11y checkbox?
      aria-checked={checked}
      className={c(
        s['checkbox'],
        controlAlignment === 'center' && s['align-items-center'],
        className
      )}
      inputClassName={c(commonStyles['input'], inputClassName)}
      // TODO: Refactor away the need to unset the default checkbox font?
      labelClassName={s['label']}
      isChecked={checked}
      id={name}
      innerRef={node => setRefs([ref, innerRef], node)}
      {...rest}
    >
      <ListItemContent {...contentProps} />
    </Checkbox>
  );
};

ListItemCheckbox.displayName = 'ListItemCheckbox';

export default ListItemCheckbox;
